module.exports = __webpack_public_path__ + "img/Emperor-Team-Logo-Template.jpg";